import sortBy from 'lodash/sortBy';
import { useMemo } from 'react';
import { ApiTypes } from 'shared/data/webApp/v2';

import { useGetRecognizedOcrAttachment } from '../../../../../hooks/useGetRecognizedOcrAttachment';
import { useOcrData } from '../../../../../hooks/useOcrData';
import { useRequest } from './useRequest';

export const useOcrLinesItems = () => {
    const request = useRequest();

    const ocrAttachment = useGetRecognizedOcrAttachment(request);

    const { data: ocrData } = useOcrData(request, ocrAttachment?.id);

    return useMemo(
        () =>
            ocrData &&
            (sortBy(
                ocrData.document?.lineItems,
                'lineOrder'
            ) as ApiTypes['OcrContractsModelsQBooksRecognizedLineItemAnswerCamelCased'][]),
        [ocrData]
    );
};
